import store from '../store/store'

// converts object to parameter array, handles arrays
// TODO: check if this can be deprecated
export function buildParams (object) {
  let params = []
  if (object) {
    for (const p in object) {
      if (object.hasOwnProperty(p)) {
        const value = object[p]
        if (value !== null && undefined !== value) {
          if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
              params.push(p + '=' + encodeURIComponent(value[i]))
            }
          } else {
            params.push(p + '=' + encodeURIComponent(value))
          }
        }
      }
    }
  }
  return params
}

// joins params array and adds '?' prefix if needed
// TODO: check if this can be deprecated
export function buildQuery (object, queryType = null) {
  if (!queryType) {
    const params = (Array.isArray(object) ? object : buildParams(object))
    return (params.length > 0 ? `?${params.join('&')}` : '')
  }
  let queryString = ''
  switch (queryType) {
    case 'in':                                          // do something to create 'IN' query
      for (let o in object) {
        if (!object.hasOwnProperty(o)) continue
        if (queryString.includes('?')) {
          queryString += `${o}__in=${[...object[o]]}&`
        } else {
          queryString = `?${o}__in=${[...object[o]]}&`
        }
      }
      return queryString.slice(0, -1)
    case 'icontains':
      for (let o in object) {
        if (!object.hasOwnProperty(o)) continue
        if (queryString.includes('?')) {
          queryString += `${o}__icontains=${object[o]}&`
        } else {
          queryString = `?${o}__icontains=${object[o]}&`
        }
      }
      return queryString.slice(0, -1)
  }
}

// reject promise if response is no bueno
export function checkStatus (response) {
  store.dispatch('checkLastRequestStatus', response)
  if (response.ok) {
    return Promise.resolve(response)
  } else {
    return Promise.reject({ code: response.status, msg: response.data.message })
  }
}

// parses JSON
export function parseJSON (response) {
  return response.json()
}

// builds request headers, with optional authToken header
export function getHeaders (token = null) {
  let _headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
  if (token) _headers['Authorization'] = `Bearer ${token}`
  return _headers
}

// builds request URI
export function buildUrl (endpoint, params, baseUrl = null) {
  if (params && Array.isArray(params)) return baseUrl + (endpoint || '') + buildQuery(...params)
  return baseUrl + (endpoint || '') + buildQuery(params)
}

// builds URL with multiple query params
export function buildUrlWithQuery (endpoint, query, baseUrl = null) {
  if (!query || !Object.keys(query).length) return baseUrl + (endpoint || '')
  return baseUrl + (endpoint || '') + '?' + toQueryString(query)
}

/**
 * Builds a query string out of an object
 * @param obj
 * @return {string}
 */
export function toQueryString (obj) {
  let qs = []
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) qs.push(p + '=' + encodeURIComponent(obj[p]))
  }
  return qs.join('&')
}

